"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectStore = void 0;
const utils_1 = require("../utils");
const Store_1 = require("./Store");
class ObjectStore extends Store_1.Store {
    storeObject(value) {
        if (!(0, utils_1.isObject)(value))
            return;
        const objectId = (0, utils_1.randomStrId)();
        this.store(objectId, value);
        Object.values(value).forEach((v) => this.storeObject(v));
    }
    getObjectOf(objectId) {
        return this.getById(objectId);
    }
    getObjectIdOf(object) {
        return this.getByValue(object);
    }
}
exports.objectStore = new ObjectStore();
